import React, { FC } from 'react';
import { FormatTime } from '../Utilities';

interface HeaderProps {
    time: number;
    score: number;
}

const Header: FC<HeaderProps> = ({ time, score, children }) => {

    return (
        <header className="header">
            <div className="timer">{FormatTime(time)}</div>
            <div className="title">Scordle</div>
            <div className="score">{score}</div>
        </header>

    );
};

export default Header;
